var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-membership"},[_c('router-link',{staticClass:"btn-back",attrs:{"to":"/"}},[_c('span',[_vm._v("Back to Dashboard")])]),_c('h1',{staticClass:"h2"},[_vm._v("Membership")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }